import React, { FC } from 'react';

import { NativeResources } from '@ariksa/inventory-core/api';
import { Box, HStack, Stack } from '@chakra-ui/react';
import { isEmpty, map } from 'lodash';
import { useSelector } from 'react-redux';

import {
  DetailsIdentifier,
  getIcon,
  renderRiskContextIcon,
  Tag,
} from 'components/DataDisplay';
import { useGetDescription } from 'containers/ActiveCloudResource/Components/ResourceMetadataDrawer/ResourceMetadata/hooks/useGetDescription';
import { selectActiveResource } from 'containers/ActiveCloudResource/selectors';
import { CloudAccountName } from 'containers/Setup/CloudAccounts/utils';

export const SnowflakeSummary: FC = () => {
  const {
    resourceInsight,
    resourceDetails,
    resourceType,
    resourceAccountId,
    riskContext,
  } = useSelector(selectActiveResource);
  const { data: insight } = resourceInsight;
  const { data: details } = resourceDetails;

  const { getDescription } = useGetDescription();

  return (
    <HStack spacing={6} align="flex-start">
      <Stack minW={64} spacing={3}>
        <DetailsIdentifier
          label="Cloud"
          value={
            <HStack spacing={2}>
              <Box w={6}>{getIcon(insight?.provider ?? 'snowflake')}</Box>
              <CloudAccountName accountId={resourceAccountId} />
            </HStack>
          }
        />
        {resourceType === NativeResources.SnowflakeUsers && (
          <DetailsIdentifier label="Email" value={details?.config?.email} />
        )}
        {resourceType !== NativeResources.SnowflakeUsers && (
          <DetailsIdentifier
            label="Cloud ID"
            value={insight?.resource_id ?? details?.meta?.resource_id ?? 'None'}
          />
        )}
        {resourceType === NativeResources.SnowflakeTables ? (
          <DetailsIdentifier
            label="Risk Context"
            align="center"
            isLoading={riskContext.isLoading}
            spacing={4}
            value={
              isEmpty(riskContext.data) ? (
                'None'
              ) : (
                <HStack spacing={0}>
                  {map(riskContext.data, (item, index) => (
                    <Box key={index + '-risk-context'}>
                      {renderRiskContextIcon(item)}
                    </Box>
                  ))}
                </HStack>
              )
            }
          />
        ) : (
          <DetailsIdentifier
            label="Owner"
            value={insight?.owner ?? details?.config?.owner ?? 'None'}
          />
        )}
      </Stack>
      <Stack>
        <DetailsIdentifier
          label="Tags"
          value={
            !!insight?.tags?.length
              ? insight?.tags?.map((o, index) => {
                  const key = o?.Key ?? o?.key;
                  const value = o?.Value ?? o?.value;

                  const label = key + ': ' + value;
                  return <Tag key={index + '-tag'} label={label} />;
                })
              : 'None'
          }
        />
        <DetailsIdentifier
          label={
            resourceType === NativeResources.SnowflakeTables
              ? 'Description'
              : 'Comment'
          }
          value={
            resourceInsight.isLoading || resourceDetails.isLoading
              ? 'None'
              : getDescription()
          }
        />
        {resourceType === NativeResources.SnowflakeUsers && (
          <DetailsIdentifier
            label="Identity Provider"
            value={insight?.cloud_type}
          />
        )}
      </Stack>
    </HStack>
  );
};
